module.exports = __webpack_public_path__ + "60d5e5488e273d455f67ef0e83b9256c.fbx";